module.exports = __webpack_public_path__ + "static/exterior-2-6fc6fc667f489b2eea74754abab031e3.jpg";